<template>
  <div>
    <el-input
      ref="input"
      type="text"
      v-bind="{...$props, ...$attrs}"
      v-model="displayValue"
      @blur="onBlur"
      @focus="onFocus"
      @change="onChange"
    >
      <template slot="prefix">
        <slot name="prefix"></slot>
      </template>
      <template slot="suffix">
        <slot name="suffix"></slot>
      </template>
      <template slot="prepend">
        <slot name="prepend"></slot>
      </template>
      <template slot="append">
        <slot name="append"></slot>
      </template>
    </el-input>
  </div>
</template>

<script>
  import numberFormatter from './../../services/NumberFormatter'

  export default {
    props: {
      value: {
        defalut: ''
      }
    },
    data: function () {
      return {
        isInputActive: false
      }
    },
    computed: {
      displayValue: {
        get () {
          if (!this.value) {
            return ''
          }

          if (this.isInputActive) {
            return numberFormatter.localize(this.value)
          }

          return numberFormatter.localize(numberFormatter.round(this.value))
        },
        set (newValue) {
          this.$emit('input', numberFormatter.softParse(newValue))
        }
      }
    },
    methods: {
      onBlur (evt) {
        this.isInputActive = false
        this.$emit('blur', evt)
      },
      onFocus (evt) {
        this.isInputActive = true
        this.$emit('focus', evt)
      },
      onChange (evt) {
        const rounded = numberFormatter.round(numberFormatter.parse(this.value)).toString()
        this.$emit('change', rounded)
        this.$emit('input', rounded)
      },
      focus () {
        this.$refs['input'].focus()
      }
    }
  }
</script>
